import React from 'react';
import PropTypes from 'prop-types';
import { contextType } from 'types';
import SelectableList from 'components/SelectableList';
import ContextItem from './components/ContextItem';

const ContextsList = props => {
  const {
    contexts,
    selectedContext,
    selectedContextIndex,
    onSelect,
    onDeselect,
  } = props;
  return (
    <SelectableList
      items={contexts}
      // FIXME: use `renderer` instead of `ItemComponent`
      ItemComponent={<ContextItem />}
      selectedItem={selectedContext}
      currentItemIndex={selectedContextIndex}
      selectItem={onSelect}
      deselectItem={onDeselect}
    />
  );
};

ContextsList.propTypes = {
  contexts: PropTypes.arrayOf(contextType).isRequired,
  selectedContext: contextType.isRequired,
  selectedContextIndex: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  onDeselect: PropTypes.func.isRequired,
};

export default ContextsList;
